if (!customElements.get("predictive-search")) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
    }

    get getSectionQuery() {
      let id = this.getAttribute("section-id");
      if (!id || id.length === 0) return "";
      return "&section_id=" + id;
    }

    get getQuery() {
      let terms = this.getAttribute("search-terms");
      if (!terms) return false;

      return window.Shopify.routes.root + "search/suggest?q=" + terms;
    }

    getFullSearchQuery() {
      let terms = this.getAttribute("search-terms");
      if (!terms) return false;

      return window.Shopify.routes.root + "search?q=" + terms;
    }

    loadContent() {
      var requestResponse;
      var resourceType = this.getAttribute("data-type");

      var limit = 10; // current max from api anyways //
      if (this.getAttribute("data-limit")) {
        limit = this.getAttribute("data-limit");
      }

      var fetchURI =
        this.getQuery +
        "&resources[type]=" +
        resourceType +
        "&resources[limit]=" +
        limit +
        this.getSectionQuery;

      if (resourceType == "article") {
        fetchURI =
          this.getFullSearchQuery() +
          "&type=article&" +
          "options%5Bprefix%5D=last" +
          this.getSectionQuery;
      }

      fetch(fetchURI)
        .then((res) => {
          requestResponse = res;
          return res.text();
        })
        .then((text) => {
          var markup = new DOMParser().parseFromString(text, "text/html");
          var section = markup.querySelector(
            ".shopify-section .predictive-search-content"
          );

          this.innerHTML = section.innerHTML;
        });
    }

    connectedCallback() {
      this.loadContent();
    }
  }

  customElements.define("predictive-search", PredictiveSearch);
}

class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.input = this.form.querySelector('input[name="q"]');
    this.domParser = new DOMParser();
    this.activeQuery;

    if (this.input) {
      this.input.addEventListener(
        "keyup",
        debounce((event) => {
          this.onSearch(event);
        }, 175)
      );

      this.input.addEventListener(
        "change",
        debounce((event) => {
          this.onSearch(event);
        }, 175)
      );

      this.form.addEventListener(
        "reset",
        debounce((event) => {
          this.input.value = "";
          this.activeQuery = "";
          this.input.focus();
        }, 175)
      );

      this.input.addEventListener("focus", (event) => {
        this.onSearch(event);
      });

      this.input.addEventListener("blur", (event) => {});
    }
  }

  onSearch() {
    if (this.input.value.length == 0) {
      this.activeQuery = "";
      this.closest("search-modal").setAttribute("data-active-mode", "noquery");
      return;
    }

    if (this.input.value.length > 0) {
      if (this.input.value != this.activeQuery) {
        this.searchAPI(this.input.value);
      }
    }
  }

  renderSearch() {
    this.searchResponseParsed = this.domParser.parseFromString(
      this.searchResponse,
      "text/html"
    );

    this.searchReponseContent =
      this.searchResponseParsed.querySelector(".shopify-section").innerHTML;
    document.querySelector(".searchmodal-tabs").innerHTML =
      this.searchReponseContent;

    (function () {
      const contentWrapper = document.querySelector(
        ".searchmodal-tabs[data-active-content]"
      );
      if (!contentWrapper) return;
      const tabs = contentWrapper.querySelectorAll("[data-set-active-content]");
      var tabOuter = document.querySelector(".searchmodal-tabs");
      tabOuter.setAttribute("data-active-content", "products");

      if (!tabs) return;
      tabs.forEach((tab) =>
        tab.addEventListener("click", () => {
          contentWrapper
            .querySelector(".tab-button--active")
            .classList.remove("tab-button--active");
          tab.classList.add("tab-button--active");
          contentWrapper.setAttribute(
            "data-active-content",
            tab.getAttribute("data-set-active-content")
          );
        })
      );
    })();
  }

  searchAPI(query) {
    this.formData = new FormData(this.form);
    this.searchParams = new URLSearchParams(this.formData);
    this.searchParams.set("section_id", "async-search-modal-products");
    this.searchURL =
      window.Shopify.routes.root + "search?" + this.searchParams.toString();

    fetch(this.searchURL)
      .then((response) => {
        return response.text();
      })
      .then((responseText) => {
        this.activeQuery = query;
        this.searchResponse = responseText;
        this.renderSearch();
        this.closest("search-modal").setAttribute(
          "data-active-mode",
          "hasquery"
        );
      });
  }

  connectedCallback() {}
}

customElements.define("search-form", SearchForm);



